const chat = require('../../../../../components/chat/chat')
const {
	buildChatCardWarning,
	friendlySectionName,
} = require('../../../../../components/chat/chat-card-warning')

export function start(detail) {
	if (obj[detail.act]) {
		obj[detail.act].start(detail)
	}
}

const obj = {
	loadAllSuggestions: { start: (detail) => { loadAllSuggestions(detail) } },
}

const SUGGESTION_ALL_QUESTIONS = [
	'Which item–provider pairs have the best ROI?',
	'Which item–customer pairs have the best ROI?',
]

function getGeneralQuestions(type) {
	if (type === 'suggestionAll') {
		return SUGGESTION_ALL_QUESTIONS
	}
}

function loadAllSuggestions(detail) {
	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName('suggestion'),
		typeLabel: 'General ideas and recommendations',
		recordId: '—',
		details: [
			{
				label: 'What includes',
				value: 'Products, customers, providers and recent movements (summary view)',
			},
			{
				label: 'Amount of information',
				value: 'Only a part of the real data, to make the answers fast',
			},
			{ label: 'Your session', value: 'Only you see this conversation in your account' },
		],
		scopeNote:
			'The assistant works with a wide summary. If you need something very specific, open the product, customer or provider and ask from there.',
	})

	chat.start({
		dest: 'chat',
		act: 'quickview',
		actQuickview: 'show',
		type: 'suggestionAll',
		entity: 'suggestion',
		question: detail.question ?? '',
		generalQuestions: getGeneralQuestions('suggestionAll'),
		cardWarning: cardWarning,
		ev: detail.ev,
	})
}
